<template lang="pug">
    div(class="step-container")
        slot(name="operator-component")
        div(class="form-container")
            div(class="form-inner")
                slot(name="form-component")
                template(v-if="btnId == 'submit'")
                  p.privacyPolicy
                    a(href="./privacy.html" target="_blank")  利用規約
                  a(:id="btnId" class="btn-next" :class="{ 'btn-active': validate }" @click="submit" key="submit")
                      |{{ btnText + "&nbsp→" }}
                  p.submitMessage {{ submitStatus.message }}
                template(v-else)
                  a(:id="btnId" class="btn-next" :class="{ 'btn-active': validate }" @click="scroll" key="scroll")
                      |{{ btnText + "&nbsp→" }}
</template>
<script>
export default {
  name: "StepContainer",
  props: {
    btnId: { type: String, required: true },
    btnText: { type: String, required: true },
    validate: { type: Boolean, required: true },
    formData: { type: Object },
    submitStatus: { type: Object }
  },
  methods: {
    scroll: function(e) {
      if (this.validate) {
        if (e.target.id !== "submit") {
          const nextStep = "#step" + e.target.id.replace("toStep", "");
          this.$emit("showNextStep", nextStep.replace("#", ""));
          this.$nextTick(() => this.$scrollTo(nextStep));
        }
      }
    },
    submit: function() {
      // フォーム全体のバリデートしたい
      if (!this.validate || !this.submitStatus.activateSubmit) {
        return false;
      }
      this.$emit("submitForm");
    }
  }
};
</script>
<style lang="scss">
.submitMessage {
  text-align: center;
  font-size: 3rem;
}
.privacyPolicy {
  text-align: center;
  padding-bottom: 40px;
  a:link {
    color: #7bc745;
    text-decoration: underline;
  }
}
</style>
